import { Expose } from "class-transformer";

export class CreateServiceDto {
  @Expose()
  name: string;

  @Expose()
  externalCode?: string;
}
